import { useState } from 'react'

export default function Accordion({ items }) {
  const [openId, setOpenId] = useState(null)

  const toggle = (id) => setOpenId((prev) => (prev === id ? null : id))

  return (
    <div className="aside__accordion accordion">
      {Object.entries(items).map(([key, section]) => {
        const isOpen = openId === section.id

        return (
          <div className="card" key={key}>
            <div className="card-header p-0">
              <h4
                className="accordion__header p-3 mb-0"
                role="button"
                tabIndex={0}
                aria-expanded={isOpen}
                aria-controls={`collapse-${section.id}`}
                onClick={() => toggle(section.id)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault()
                    toggle(section.id)
                  }
                }}
              >
                {section.name}
              </h4>
            </div>

            <div
              id={`collapse-${section.id}`}
              className={`collapse${isOpen ? ' show' : ''}`}
              style={{
                display: isOpen ? 'block' : 'none',
              }}
            >
              <div className="card-body">
                {Object.entries(section.universities).map(
                  ([groupName, universities]) => (
                    <div key={universities[0]?.name ?? groupName}>
                      {groupName && (
                        <p className="listItem__heading pl-2 mb-1">
                          {groupName}
                        </p>
                      )}
                      <ul
                        className={`accordion__list pl-2${groupName ? ' mb-4' : ''}`}
                      >
                        {universities.map((uni, i) => (
                          <li className="accordion__listItem mb-2" key={i}>
                            {uni.link ? (
                              <a
                                href={uni.link}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <p className="text-primary mb-0">{uni.name}</p>
                                {uni.text && (
                                  <p className="small text-muted mb-0">
                                    {uni.text}
                                  </p>
                                )}
                              </a>
                            ) : (
                              <div>
                                <p className="text-primary mb-0">{uni.name}</p>
                                {uni.text && (
                                  <p className="small text-muted mb-0">
                                    {uni.text}
                                  </p>
                                )}
                              </div>
                            )}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )
                )}
              </div>
            </div>
          </div>
        )
      })}
    </div>
  )
}